module.exports = __webpack_public_path__ + "static/media/14.e2975ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/14.png
// module id = 1387
// module chunks = 0